module.exports = __webpack_public_path__ + "static/media/entertainment.a3ab1d1f.png";